<template>
  <div>
    <div class='log' v-if="userPermissions.indexOf('artist_log') !== -1">
      <div>
        <div class='theme-border flex-sb p-10 mb8' v-if='!detailMode'>
          <div></div>
          <div>
            <el-link @click='getList' style='font-size: 20px;font-weight: bolder'>操作日志</el-link>
          </div>
          <div><span style='display: none'>{{artistId}}</span></div>
        </div>
        <!--    渲染表格-->
        <m-table :showIndex='true' :offset='offset' :tableData='dataList' :columns='columns'
                 :loading='loadingStatus' border>

        </m-table>
        <div :class="detailMode ? 'detail-pagination-row' : 'flex-sb'">
          <el-button type='text' icon='el-icon-refresh' @click='getList'>刷新</el-button>

          <!--    渲染分页-->
          <m-pagination :total.sync='total' :limit.sync='pagingData.page_size' :page.sync='pagingData.current_page'
                        @pagination='getList'/>
        </div>

      </div>
    </div>
    <div v-else>
      暂无查看操作日志权限
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ArtistLog',
  computed: {
    ...mapGetters(['userPermissions'])
  },
  props: {
    artistId: {
      type: String,
      default() {
        return ''
      }

    },
    detailMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingStatus: false,
      activeNames: ['1'],
      offset: 0,
      total: 0,
      pagingData: {
        page_size: 10,
        current_page: 1
      },
      dataList: [],//日志
      columns: [
        {
          title: '日志内容',
          value: 'message',
          width: 400,
          align: 'left'
        },
        {
          title: '操作时间',
          value: 'created_at',
          width: 120
        },
        // {
        //   title: '修改时间',
        //   value: 'updated_at',
        //   width: 120
        // }
      ]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleChange() {
      // console.log(val);
      this.getList()
    },
    async getList() {
      this.loadingStatus = true
      this.dataList = []
      if (this.artistId) {
        const { list, pages } = await this.$api.getArtistLog(Object.assign({ artist_id: this.artistId }, this.pagingData))
        this.loadingStatus = false
        this.$nextTick(() => {
          this.dataList = list
          this.total = pages.total
          this.offset = pages.offset
          this.pagingData.current_page = pages.current_page
          this.pagingData.page_size = pages.page_size
        })
      }
    }
  }
}
</script>

<style scoped>

.log-message {
  font-style: initial;
  margin-left: 10px;
  font-size: 12px;
}

.detail-pagination-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
